import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from '../components/RequireAuth';
import AppShell from '../layouts/AppShell';
import ApprovalPage from '../pages/ApprovalPage';
import LoginPage from '../pages/Login';
import MapPage from '../pages/MapPage';
import NotFound from '../pages/NotFound';
import StarPage from '../pages/StarPage';
import SystemSettingsPage from '../pages/SystemSettingsPage';
import SettingsIndexRedirect from '../features/settings/SettingsIndexRedirect';
import UsersPanel from '../features/settings/UsersPanel';
import RolesPanel from '../features/settings/RolesPanel';
import ProjectTypesPanel from '../features/settings/ProjectTypesPanel';
import TaskCategoriesPanel from '../features/settings/TaskCategoriesPanel';
import TaskTemplatesPanel from '../features/settings/TaskTemplatesPanel';
import AuditPanel from '../features/audit/AuditPanel';

/** 路由表 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/map" replace />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/star" element={<StarPage />} />
          <Route path="/approvals" element={<ApprovalPage />} />
          {/* P6.29：操作日志页合并 —— 唯一入口为「系统设置 › 操作日志」(/settings/audit)。
              旧 /audit 顶层路由保留为软重定向，手输 URL 或旧书签不落 404。 */}
          <Route path="/audit" element={<Navigate to="/settings/audit" replace />} />
          <Route path="/settings" element={<SystemSettingsPage />}>
            <Route index element={<SettingsIndexRedirect />} />
            <Route path="users" element={<UsersPanel />} />
            <Route path="roles" element={<RolesPanel />} />
            <Route path="project-types" element={<ProjectTypesPanel />} />
            <Route path="task-categories" element={<TaskCategoriesPanel />} />
            <Route path="task-templates" element={<TaskTemplatesPanel />} />
            <Route path="audit" element={<AuditPanel />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
